<template>
	<j-base-multi-select-with-flexible-value
		:id="id"
		:options="options"
		:value="value"
		:placeholder="$t('select_course')"
		:allowMultiselect="false"
		:allowSearch="true"
		:allowLocalSearch="true"
		:status="status"
		:isLoading="isLoading"
		valueKey="id"
		nameKey="name"
		:size="size"
		@input="onInput($event)"
		@focus="fetch"
	/>
</template>

<script>
/**
 * This component is reposnible for displaying all available courses
 * @returns Array with one Objects inside that represents selected course
 */

import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JBaseMultiSelectWithFlexibleValue },
	props: {
		value: {
			validator(value) {
				return value === null || value instanceof Array || value === undefined
			},
			required: true
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		size: {
			type: String,
			required: false,
			default: "medium"
		}
	},

	data: () => ({
		options: [],
		isLoading: false
	}),

	methods: {
		onInput(value) {
			this.$emit("input", value)
		},

		async fetch() {
			const query = gql`
				query courses {
					courses {
						list {
							id
							name
						}
					}
				}
			`
			const variables = {}

			this.isLoading = true
			let res = await api({ query, variables })
			this.isLoading = false

			if (res.errors) {
				return
			}

			this.options = res.data.courses.list
		}
	}
}
</script>
